export default __webpack_public_path__ + "static/media/i10.11c17125.svg";